<template>
  <div>
    <section class="section is-title-bar">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Franchisee</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-input
              placeholder="Search..."
              type="search"
              v-model="searchTerm"
              @input="customSearch(searchTerm)"
            ></b-input>
          </div>
          <div class="level-item">
            <button
              class="button is-small is-link"
              v-if="isSuperAdmin"
              @click="toggleModal"
              title="Search by filter"
            >
              <b-icon icon="filter" size="is-small"></b-icon>
            </button>
          </div>
          <div class="level-item">
            <a
              title="Sync with B2B"
              class="button is-small is-link"
              v-if="isWrite"
              v-on:click="getUpdatedFranchisees"
            >
              <b-icon icon="lan-connect" size="is-small"></b-icon>
            </a>
          </div>
          <div class="level-item">
            <a
              title="Add"
              class="button is-small is-link"
              v-if="isWrite"
              v-on:click="addFranchise()"
            >
              <b-icon icon="plus" size="is-small"></b-icon>
            </a>
          </div>
        </div>
      </div>
      Total Records :
      <b>{{ total }}</b>
    </section>
    <section class="section is-main-section">
      <card-component class="has-table has-mobile-sort-spaced">
        <b-table
          :checked-rows.sync="checkedRows"
          :checkable="checkable"
          :loading="isLoading"
          paginated
          :per-page="perPage"
          :hoverable="true"
          default-sort="updatedAt"
          default-sort-direction="DESC"
          :data="searchFilterArray"
        >
          <template slot-scope="props">
            <b-table-column
              label="Franchisee Name"
              field="companyName"
              sortable
            >
              {{ props.row.companyName }}</b-table-column
            >
            <b-table-column label="Zone" field="region">{{
              props.row.region
            }}</b-table-column>
            <b-table-column
              label="Center Type"
              field="franchiseeModel.title"
              sortable
            >
              {{ props.row.franchiseeModel.title }}</b-table-column
            >
            <b-table-column label="Franchisee Type" field="type" sortable
              >{{ props.row.type }}
            </b-table-column>
            <b-table-column label="Mobile No" field="mobileno" sortable
              >{{ props.row.mobileno }}
            </b-table-column>
            <b-table-column label="Academic Year Start Date" field="AcademicStartDate" sortable
              >
              {{formatDate(props.row.academicStartDate) }}
            </b-table-column>
            <b-table-column label="Academic Year End Date" field="AcademicEndDate" sortable
              >
              {{ formatDate(props.row.academicEndDate) }}
            </b-table-column>
            <b-table-column label="Status" field="isActive" sortable centered>
              <span
                v-bind:class="getClass(props.row.isActive)"
                class="is-medium is-capitalized"
                >{{ props.row.isActive ? 'Active' : 'deactive' }}</span
              >
            </b-table-column>
            <b-table-column label="Sample Kit" field="placedorder">
              <b-button
                type="is-info"
                @click.prevent="
                  sampleKitDialog = true
                  selectedFranchiseeId = props.row.id
                "
                >Place Order</b-button
              >
            </b-table-column>
            <b-table-column label="Updated By" field="updatedBy" sortable
              >{{ props.row.updatedBy }}
            </b-table-column>
            <b-table-column
              label="Action"
              custom-key="actions"
              class="is-actions-cell"
              width="140"
              centered
            >
              <div class="buttons">
                <router-link
                  v-if="isWrite"
                  :to="{
                    name: 'EditFranchisee',
                    params: { franchiseeId: props.row.id }
                  }"
                  class="button is-info is-small btnicon"
                  title="Edit"
                >
                  <b-icon icon="pencil" size="is-small" />
                </router-link>
                <router-link
                  :to="{
                    name: 'ViewFranchisee',
                    params: { franchiseeId: props.row.id }
                  }"
                  class="button is-primary is-small btnicon"
                  title="View"
                >
                  <b-icon icon="eye" size="is-small" />
                </router-link>
                <button
                  class="button is-small is-danger"
                  type="button"
                  @click.prevent="deactivateFranchisee(props.row.id)"
                  v-if="props.row.isActive && props.row.b2bID && isWrite"
                  title="Deactivate"
                >
                  <b-icon icon="trash-can" size="is-small" />
                </button>
                <button
                  class="button is-small is-success"
                  type="button"
                  @click.prevent="restoreFranchisee(props.row.id)"
                  v-if="!props.row.isActive && props.row.b2bID && isWrite"
                  title="Restore"
                >
                  <b-icon icon="restore" size="is-small" />
                </button>
                <button
                  class="button is-small is-warning"
                  type="button"
                  @click.prevent="b2bactive(props.row.id)"
                  v-if="!props.row.b2bID && isWrite"
                  title="B2B Active"
                >
                  <b-icon icon="check" size="is-small" />
                </button>
              </div>
            </b-table-column>
          </template>
          <section class="section" slot="empty">
            <div class="content has-text-grey has-text-centered">
              <template v-if="isLoading">
                <p>
                  <b-icon icon="dots-horizontal" size="is-large" />
                </p>
                <p>Fetching data...</p>
              </template>
              <template v-else>
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
                <p>Nothing's here&hellip;</p>
              </template>
            </div>
          </section>
        </b-table>
      </card-component>
      <!-- <b-pagination :total="total" :current.sync="current" :range-before="rangeBefore" :range-after="rangeAfter" :order="order" :size="size" :per-page="perPage" :icon-prev="prevIcon" :icon-next="nextIcon" aria-next-label="Next page"
      aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page" @change="paginChange($event)">
      </b-pagination>-->
    </section>

    <!-- filter modal -->
    <div class="modal" :class="{ 'is-active': toggleFilter }">
      <div class="modal-background"></div>
      <form class="modal-card is-small" style="width: 50rem">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <strong>Franchise Filter</strong>
          </p>
          <button
            class="delete"
            type="button"
            @click="toggleFilter = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="searchFranchisee">
            <div class="columns is-multiline">
              <div class="column">
                <div class="field">
                  <label class="label">Zone</label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select
                        name="selectZone"
                        v-model="filter.region"
                        @change="getZoneWiseFranchisee()"
                      >
                        <option value>--Select--</option>
                        <option
                          v-for="region in regionArr"
                          v-bind:key="region.name"
                          v-bind:value="region.name"
                        >
                          {{ region.name }}
                        </option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">Franchisee Name</label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select name="companyName" v-model="filter.franchiseeID">
                        <option value>--Select--</option>
                        <option
                          :value="franchisee.id"
                          v-for="franchisee in zoneWiseFranchisees"
                          :key="franchisee.id"
                        >
                          {{ franchisee.companyName }}
                        </option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">Center Type</label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select name="model" v-model="filter.modelID">
                        <option value>--Select--</option>
                        <option
                          :value="model.id"
                          v-for="model in models"
                          :key="model.id"
                        >
                          {{ model.title }}
                        </option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">State</label>
                  isWrite
                  <div class="control">
                    <input class="input" type="text" v-model="filter.state" />
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">City</label>
                  <div class="control">
                    <input class="input" type="text" v-model="filter.city" />
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">Status</label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select name="status" v-model="filter.isActive">
                        <option value>--Select--</option>
                        <option value="true">Active</option>
                        <option value="false">Deactive</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">Franchisee Type</label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select name="status" v-model="filter.type">
                        <option value>--Select--</option>
                        <option value="COCO">COCO</option>
                        <option value="FOFO">FOFO</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <hr />
            <div class="columns form-row">
              <div class="column has-text-right">
                <button class="button is-success m-r-10" type="submit">
                  Apply
                </button>
                <button class="button is-dark" type="reset" @click="resetAll()">
                  Reset
                </button>
              </div>
            </div>
          </form>
        </section>
      </form>
    </div>
    <div class="modal" :class="{ 'is-active': toggleSync }">
      <div class="modal-background"></div>
      <form class="modal-card is-small" style="width: 50rem">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <strong>Franchisees for sync</strong>
          </p>
          <button
            class="delete"
            type="button"
            @click="toggleSync = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="syncFranchiseesWithB2B">
            <div class="columns is-multiline">
              <div
                class="column is-4"
                v-for="obj in updatedFranchisses"
                :key="obj.id"
              >
                <b-checkbox :native-value="obj" v-model="franchiseeForSync">
                  {{ obj.companyName }}
                </b-checkbox>
              </div>
            </div>
            <hr />
            <div class="columns form-row">
              <div class="column has-text-right">
                <button class="button is-success m-r-10" type="submit">
                  Sync With B2B
                </button>
                <button
                  class="button is-dark"
                  type="reset"
                  @click="toggleSync = false"
                >
                  close
                </button>
              </div>
            </div>
          </form>
        </section>
      </form>
    </div>
    <div class="modal" :class="{ 'is-active': isSyncResult }">
      <div class="modal-background"></div>
      <form class="modal-card is-small" style="width: 50rem">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <strong>Franchisee update</strong>
          </p>
          <button
            class="delete"
            type="button"
            @click="isSyncResult = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="getUpdatedFranchisees">
            <div class="columns is-multiline">
              <div class="column is-3">
                <div class="field">
                  <label class="label"
                    ><b>Succeed:</b>{{ syncResult.success }}</label
                  >
                </div>
              </div>
              <div class="column is-3">
                <div class="field">
                  <label class="label"
                    ><b>Failed:</b>{{ syncResult.failure }}</label
                  >
                </div>
              </div>
            </div>
            <div class="columns is-multiline">
              <div
                class="column is-10"
                v-for="obj in syncResult.result"
                :key="obj.franchiseeID"
              >
                <p>
                  <b>{{ obj.companyName }}</b
                  >: &nbsp;&nbsp; {{ obj.message }}
                </p>
              </div>
            </div>
            <hr />
            <div class="columns form-row">
              <div class="column has-text-right">
                <button class="button is-success m-r-10" type="submit">
                  OK
                </button>
              </div>
            </div>
          </form>
        </section>
      </form>
    </div>
    <!--SAMPLE KIT PROMPT Start-->
    <v-dialog v-model="sampleKitDialog" persistent max-width="500">
      <v-card>
        <v-card-title> Do you want to place Sample Kit order ? </v-card-title>
        <v-card-text>
          <v-radio-group v-model="productCategory" row>
            <v-radio
              color="accent"
              v-for="(category, index) in productCategoryOptions"
              :key="index"
              :label="category.label"
              :value="category.value"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="gray"
            @click="
              sampleKitDialog = false
              selectedFranchiseeId = null
            "
          >
            Cancel
          </v-btn>
          <v-btn
            color="accent"
            @click="
              sampleKitDialog = false
              placeSampleKitOrder()
            "
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--SAMPLE KIT PROMPT End-->
  </div>
</template>

<script>
// @ is an alias to /src
import CardComponent from '@/components/template/CardComponent'
// import stores from '@/stores'
import constants from '@/utils/constants'
import Utils from '@/utils'
import _ from 'lodash'

export default {
  name: 'ListFranchisee',
  components: {
    CardComponent
  },
  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchTerm: '',
      searchFilterArray: [],
      isWrite: false,
      data: [],
      total: 0,
      current: 1,
      rangeBefore: 3,
      rangeAfter: 1,
      order: 'is-right',
      size: '',
      isSimple: false,
      isRounded: false,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      isModalActive: false,
      trashObject: null,
      isLoading: false,
      paginated: false,
      perPage: 10,
      checkedRows: [],
      content: '',
      toggleFilter: false,
      toggleSync: false,
      syncResult: {},
      isSyncResult: false,
      updatedFranchisses: [],
      franchiseeForSync: [],
      filter: {
        franchiseeID: '',
        state: '',
        city: '',
        modelID: '',
        isActive: '',
        type: '',
        region: ''
      },
      models: [],
      tempFranchisees: [],
      zoneWiseFranchisees: [],
      loadingComponent: null,
      isSuperAdmin: false,
      sampleKitDialog: false,
      selectedFranchiseeId: null,
      productCategory: '',
      productCategoryOptions: [],
      regionArr: [
        { name: 'East' },
        { name: 'West' },
        { name: 'South' },
        { name: 'North' }
      ]
    }
  },
  created () {
    this.productCategoryOptions = constants.SAMPLE_KIT_PRODUCT_CATEGORIES
    this.productCategory = this.productCategoryOptions[0].value
    this.getModelS()
    this.getFranchisee()
    this.isSuperAdmin = Utils.helper.isSuperAdmin()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  computed: {
    titleStack () {
      return ['Admin', 'Dashboard']
    }
  },
  methods: {
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.tempFranchisees
      } else {
        this.searchFilterArray = _.filter(
          this.tempFranchisees,
          (item) =>
            (item &&
              item.companyName.toLowerCase().search(value.toLowerCase()) >=
                0) ||
            (item &&
              item.firstname.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item &&
              item.type.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item &&
              item.franchiseeModel &&
              item.franchiseeModel.title
                .toLowerCase()
                .search(value.toLowerCase()) >= 0) ||
            (item &&
              item.mobileno.toLowerCase().search(value.toLowerCase()) >= 0)
        )
        this.total = this.searchFilterArray.length
      }
    },
    addFranchise: async function () {
      this.$router.push({ name: 'SaveFranchisee' })
    },
    getFranchisee: async function (pageNum) {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        this.data = response.data.rows

        this.tempFranchisees = response.data.rows
        this.tempFranchisees.forEach((e) => {
          if (e.id.toString().length === 1) {
            e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
          } else if (e.id.toString().length === 2) {
            e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
          } else {
            e.companyName = `${'(' + e.id + ')'} ` + e.companyName
          }
        })
        this.searchFilterArray = this.tempFranchisees
        this.zoneWiseFranchisees = this.tempFranchisees
        this.total = response.data.count
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.enableUniformModal = false
        console.log('error in fetching franchisee : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    paginChange (e) {
      this.current = Number(e)
      this.getFranchisee(e)
    },
    getClass: function (isActive) {
      return !isActive ? 'tag is-danger' : 'tag is-success'
    },
    deactivateFranchisee: function (franchiseeId) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to deactivate Franchisee?',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()
            /* deactive franchisee */
            await http.get(
              `${constants.API_URL}/api/franchisee/status/${franchiseeId}`
            )
            that.getFranchisee()
            this.loadingComponent.close()

            return this.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Franchisee deactivated successfully!',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in deactivating franchisee : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    },
    restoreFranchisee: function (franchiseeId) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to restore franchisee?',
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()

            /* restore franchisee */
            await http.get(
              `${constants.API_URL}/api/franchisee/status/${franchiseeId}`
            )
            that.getFranchisee()
            this.loadingComponent.close()

            return that.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Franchisee restored successfully!',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in restoring franchisee : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    },
    b2bactive: function (franchiseeId) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to activate franchisee?',
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()
            /* activate franchisee @ b2b system */
            await http.get(
              `${constants.API_URL}/api/b2b/create/franchisee/${franchiseeId}`
            )
            that.getFranchisee()
            this.loadingComponent.close()

            return that.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Franchisee activated successfully!',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in activating franchisee : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    },
    searchFranchisee: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.post(
          `${constants.API_URL}/api/franchisee/filter`,
          this.filter
        )
        this.searchFilterArray = data.rows
        this.total = data.count
        this.toggleFilter = false
        this.loadingComponent.close()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.toggleFilter = false
        this.loadingComponent.close()
        console.log('error in search franchisee : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getModelS: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/franchisee/model`
        )
        this.models = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    resetAll: function () {
      this.filter = {
        franchiseeID: '',
        state: '',
        city: '',
        modelID: '',
        isActive: '',
        type: ''
      }
    },
    getUpdatedFranchisees: async function () {
      try {
        this.isSyncResult = false
        this.updatedFranchisses = []
        this.franchiseeForSync = []
        const { data } = await http.get(
          `${constants.API_URL}/api/franchisee/get/updated-franchisees`
        )
        if (!data.length) {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'No franchisee available for syncing!',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        this.updatedFranchisses = data.map((obj) => obj.franchisee)
        if (this.updatedFranchisses) {
          this.toggleSync = true
        } else {
          this.toggleSync = false
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log(e)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    syncFranchiseesWithB2B: async function () {
      try {
        if (!this.franchiseeForSync.length) {
          return this.$buefy.dialog.alert({
            type: 'is-warning',
            message: 'Please select atleast one Franchisee',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        let franchiseeIDArray = this.franchiseeForSync.map((obj) => obj.id)
        const payload = {
          franchiseeID: franchiseeIDArray
        }
        const { data } = await http.post(
          `${constants.API_URL}/api/franchisee/sync-franchisee-with-b2b`,
          payload
        )
        this.syncResult = data
        this.isSyncResult = true
      } catch (e) {
        console.log(e)
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    placeSampleKitOrder: async function () {
      try {
        let order = await http.post(
          `${constants.API_URL}/api/order/sample-kit`,
          {
            franchiseeID: this.selectedFranchiseeId,
            productCategory: this.productCategory
          }
        )
        if (!order) {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Failed to place Sample kit order',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Order placed successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }

      // productCategory
      // this.$buefy.dialog.confirm({
      //   message: 'Do you want place sample kit order?',
      //   onConfirm: async () => {
      //     this.loadingComponent = this.$buefy.loading.open()
      //     try {
      //       let order = await http.post(`${constants.API_URL}/api/order/sample-kit`, {
      //         franchiseeID: franchiseeId
      //       })
      //       if (!order) {
      //         return this.$buefy.dialog.alert({
      //           type: 'is-danger',
      //           message: 'Failed to place Sample kit order',
      //           hasIcon: true,
      //           animation: 'zoom-out',
      //           size: 'is-medium',
      //           icon: ' mdi-exclamation',
      //           iconPack: 'mdi',
      //           ariaRole: 'alertdialog',
      //           ariaModal: true
      //         })
      //       }
      //       return this.$buefy.dialog.alert({
      //         type: 'is-success',
      //         message: 'Order placed successfully',
      //         hasIcon: true,
      //         animation: 'zoom-out',
      //         size: 'is-medium',
      //         icon: ' mdi-exclamation',
      //         iconPack: 'mdi',
      //         ariaRole: 'alertdialog',
      //         ariaModal: true
      //       })
      //     } catch (e) {
      //       const errorMessage = (e && e.response && e.response.data.message) || e.message
      //       return this.$buefy.dialog.alert({
      //         type: 'is-danger',
      //         message: errorMessage,
      //         hasIcon: true,
      //         animation: 'zoom-out',
      //         size: 'is-medium',
      //         icon: ' mdi-exclamation',
      //         iconPack: 'mdi',
      //         ariaRole: 'alertdialog',
      //         ariaModal: true
      //       })
      //     } finally {
      //       this.loadingComponent.close()
      //     }
      //   }
      // })
    },
    getZoneWiseFranchisee: async function () {
      try {
        let selectedZone = []
        selectedZone.push(this.filter.region)
        const data = await http.post(
          `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
          {
            zone: selectedZone
          }
        )
        this.zoneWiseFranchisees = data.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    toggleModal: async function () {
      this.toggleFilter = !this.toggleFilter
      await this.getFranchisee()
    },
    formatDate (dateString) {
      if (!dateString) return '-'

      const date = new Date(dateString)
      const options = { day: '2-digit', month: '2-digit', year: 'numeric' }
      return date.toLocaleDateString('en-GB', options).replace(',', '')
    }
  }
}
</script>
